import { Component, Inject, signal } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';

export class SelectOption {
  id?: string;
  value?: string;
}

@Component({
  selector: 'app-contract-limit-add-dialog',
  templateUrl: './contract-limit-add-dialog.component.html',
  styleUrls: ['./contract-limit-add-dialog.component.css'],
  standalone: false,
})
export class ContractLimitAddDialogComponent {
  // These should come from a service in the future.
  categories: Array<SelectOption> = [
    { id: 'communication', value: 'communication' },
    { id: 'data-lookup', value: 'data-lookup' },
  ];

  codes: Array<SelectOption> = [
    { id: 'sms-message', value: 'sms-message' },
    { id: 'voice-call', value: 'voice-call' },
    { id: 'white-yellow-pages', value: 'white-yellow-pages' },
  ];

  priorities: Array<SelectOption> = [
    { id: 'Emergency', value: 'Emergency' },
    { id: 'Non-Emergency', value: 'Non-Emergency' },
  ];

  create: boolean = false;
  selectedCode = signal<string | undefined>(undefined);

  limitForm: FormGroup = this.fb.group({
    id: [''],
    category: ['', [Validators.required]],
    code: ['', [Validators.required]],
    limitation: ['', [Validators.required, Validators.min(0)]],
    priority: [''],
  });

  constructor(
    private readonly fb: FormBuilder,
    @Inject(L10N_LOCALE) public locale: L10nLocale,
    @Inject(MAT_DIALOG_DATA) private readonly data?: any,
  ) {
    if (data?.action == 'edit') {
      this.create = false;
      this.selectedCode.set(this.data?.limit?.code);

      this.limitForm.patchValue({
        id: this.data?.limit?.id,
        category: this.data?.limit?.category,
        code: this.data?.limit?.code,
        limitation: this.data?.limit?.limitation,
        priority: this.data?.limit?.priority,
      });
    }

    if (data?.action == 'create') {
      this.create = true;
    }
  }

  toggleCode(codeId: string): void {
    if (this.selectedCode() === codeId) {
      this.selectedCode.set(undefined);
    } else {
      this.selectedCode.set(codeId);
    }

    this.limitForm.patchValue({ code: this.selectedCode() });
  }

  isCodeSelected(codeId: string): boolean {
    return this.selectedCode() === codeId;
  }

  formInValid(): boolean {
    return this.limitForm?.invalid;
  }
}
